import React from "react";
import AddressReveal from "../order/AddressReveal";
import OrderTypeBadge from "../order/OrderTypeBadge";
import CustomerInfoUpdatedBadge from "../order/CustomerInfoUpdatedBadge";
import { formatPlatformName } from "../../utils/utils";
import {
  getOrderContactPhone,
  getOrderAddressDisplay,
  isCustomerInfoMasked,
  getPrivacyPlaceholderLabel,
} from "../../utils/orderCustomerDisplay";
import "../order/orderCustomerDisplay.css";

/**
 * CustomerInfoTab — More tab (Figma 1:3930 / 1:3949)
 * Customer info is read-only in OneHub. Updates come only from Order Agent & Digital Catalog.
 */
const CustomerInfoTab = ({ orderDetails, formatDateTime, t }) => {
  if (!orderDetails) return null;

  const masked = isCustomerInfoMasked(orderDetails);
  const privacyLabel = getPrivacyPlaceholderLabel(t);
  const phone = masked ? privacyLabel : getOrderContactPhone(orderDetails);
  const address = masked ? privacyLabel : getOrderAddressDisplay(orderDetails);
  const notes = masked
    ? privacyLabel
    : orderDetails.delivery_instructions || orderDetails.delivery_notes || "";

  const InfoRow = ({ label, value, valueClassName = "" }) => (
    <div className="oh-order-drawer-info-row">
      <div className="oh-order-drawer-info-row__label">{label}</div>
      <div
        className={`oh-order-drawer-info-row__value${
          valueClassName ? ` ${valueClassName}` : ""
        }`}
      >
        {value || t("N/A", "N/A")}
      </div>
    </div>
  );

  return (
    <div className="oh-order-drawer-stack">
      <div className="oh-order-drawer-section-title d-flex align-items-center justify-content-between gap-2 flex-wrap">
        <span>{t("customer", "Customer")}</span>
        <CustomerInfoUpdatedBadge order={orderDetails} t={t} />
      </div>

      <div className="oh-order-drawer-customer-fields">
        <InfoRow
          label={t("name", "Name")}
          value={masked ? privacyLabel : orderDetails.customer_name}
        />

        <InfoRow
          label={t("phone", "Phone")}
          value={phone}
          valueClassName="oh-order-drawer-info-row__value--phone"
        />

        <div className="oh-order-drawer-info-row">
          <div className="oh-order-drawer-info-row__label">
            {t("address", "Address")}
          </div>
          <div className="oh-order-drawer-info-row__value">
            {masked ? (
              privacyLabel
            ) : (
              <AddressReveal address={address} showPin={false} />
            )}
          </div>
        </div>

        <div className="oh-order-drawer-info-row">
          <div className="oh-order-drawer-info-row__label">
            {t("orderType", "Order type")}
          </div>
          <div className="oh-order-drawer-info-row__value">
            <OrderTypeBadge order={orderDetails} />
          </div>
        </div>

        <InfoRow
          label={t("ordersPage.orderTable.date", "Date")}
          value={
            formatDateTime
              ? formatDateTime(orderDetails.createdAt)
              : new Date(orderDetails.createdAt).toLocaleString(undefined, {
                  day: "2-digit",
                  month: "2-digit",
                  year: "numeric",
                  hour: "2-digit",
                  minute: "2-digit",
                  second: "2-digit",
                  hour12: true,
                })
          }
        />

        <InfoRow
          label={t("platform", "Platform")}
          value={
            orderDetails.platform
              ? formatPlatformName(orderDetails.platform, t)
              : t("N/A", "N/A")
          }
        />

        <InfoRow
          label={t("branch", "Branch")}
          value={orderDetails.branchName}
        />

        <InfoRow
          label={t("paymentmethod", "Payment Method")}
          value={t(orderDetails.payment_method)}
        />

        {notes ? (
          <InfoRow
            label={t("deliverynotes", "Delivery Notes")}
            value={notes}
          />
        ) : null}
      </div>
    </div>
  );
};

export default CustomerInfoTab;
